import {clearFeedbacksByName, getInputsByName} from "../../../helpers/forms";
import Axios from "axios";
import {loading, stopLoading} from "../../../helpers/loading";
import {handleAjaxSuccess} from "../../../helpers/swalHelper";
import handleAjaxError from "../../../helpers/handleAjaxError";

function initVoeAttemptsIndex() {
	const fields = [
		'voe_attempt_frequency_hours',
		'voe_attempt_frequency_minutes',
		'max_voe_attempts',
		'max_voe_wait_time_hours',
		'max_voe_wait_time_minutes',
		'voe_contact_email',
		'process_3rd_party_voe_orders'
	];


	// Setup events
	document.querySelector('.save-settings-button')
		.addEventListener('click', () => {
			handleSaveSettingsRequest();
		})

	/**
	 * Methods
	 */

	function handleSaveSettingsRequest() {
		clearFeedbacksByName(document.body, fields);

		const data = getInputsByName(document.body, fields);

		loading()

		Axios.post(window['storeVoeAttemptsUrl'], data)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}
}

export {initVoeAttemptsIndex}
